module.exports = __webpack_public_path__ + "static/img/13077B_02_20170523_LC.08cb305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13077B_02_20170523_LC.png
// module id = FsZ5
// module chunks = 0